const formatFieldString = string => {
  // if (string.slice(-2) === 'Id') string = string.substring(0, string.length - 2)
  string = string.charAt(0).toUpperCase() + string.slice(1)
  string = string.replace(/([A-Z])/g, ' $1').trim()
  return string
}

const formatFromString = string => {
  switch (string) {
    case '':
      return '" "'
    case undefined:
      return 'not set'
    default:
      return string
  }
}

const getNameFromMasterFilesById = (value, key, masterFiles) => {
  const val = key.slice(-2) === 'Id' ? key.substring(0, key.length - 2) : key
  const file = masterFiles[`${val}s`].find(({ id }) => id === value)
  return file.name
}

// COMPARE AUDITS
const compareChanges = (previousObj, currentObj, model, masterFiles) => {
  const currentkeys = Object.keys(currentObj)
  let changes = {}
  for (const key of currentkeys) {
    const previousVal = previousObj[key]
    const currentVal = currentObj[key]
    const prevValAsString = JSON.stringify(previousVal)
    const currentValAsString = JSON.stringify(currentVal)
    if (Array.isArray(currentVal)) {
      if (prevValAsString !== currentValAsString) {
        changes[key] = JSON.stringify(currentVal)
        // changes[key] = addChanges(previousVal, currentVal, key)
      }
    }
    // else if (currentVal !== null && typeof currentVal === 'object') {
    //   const objectChanges = compareChanges(previousVal, currentVal)
    //   changes[key] = objectChanges
    // }
    else {
      if (previousVal !== currentVal) {
        changes[key] = currentVal
      }
    }
  }
  return changes
}

// const addChanges = (previousVal, currentVal, key) => {
//   switch (key) {
//     case 'rateVehicleTypes':
//       const currentVehicleTypesArr = currentVal.map(
//         ({ vehicleType }) => vehicleType.name
//       )
//       let previousVehicleTypesArr = []
//       if (!!previousVal) {
//         previousVehicleTypesArr = previousVal.map(
//           ({ vehicleType }) => vehicleType.name
//         )
//       }
//       if (currentVehicleTypesArr !== previousVehicleTypesArr) {
//         return JSON.stringify(currentVehicleTypesArr)
//       }
//       break
//     default:
//       return JSON.stringify(currentVal)
//   }
// }

const formatFromVal = (fromVal, key) => {
  if (Array.isArray(fromVal)) {
    return (fromVal = JSON.stringify(fromVal))
  } else {
    return fromVal
  }
}

const findChanges = (array, model) => {
  for (let [i, audit] of array.entries()) {
    if (!!array[i + 1]) {
      const changes = compareChanges(audit, array[i + 1], model)
      const keys = Object.keys(changes)
      if (keys.length > 0) {
        let arrayChanges = []
        for (const key of keys) {
          if (key !== 'updatedAt' && key !== 'updatedBy') {
            console.log(key)
            let fromVal = audit[key]
            fromVal = formatFromVal(fromVal)
            arrayChanges.push({
              field: formatFieldString(key),
              from: fromVal,
              to: changes[key]
            })
          }
        }
        array[i].changes = arrayChanges
      }
    }
  }
  array.splice(-1, 1)
  return array
}

export { findChanges, formatFromString }
